
<div class="wideoWreapper">
 
    <div class="videoCoverPlay"></div>

    <div>

    <div class="nativeBackground" ></div>

 
	
      <video class="nativePlayer" #target [muted]="muted" webkit-playsinline="true" playsinline="true"></video>
 <!--<div class="player streamPreview" ></div> --> 
</div>

	<div *ngIf="hasSignal" (click)="muted = !muted"  class="muteButton">

		<div class="muteButtonIcon">
		    <nb-icon *ngIf="!target.muted" style="font-size: 18px" [icon]="'volume-up-outline'" pack="eva" status="primary"></nb-icon>
		    <nb-icon *ngIf="target.muted" style="font-size: 18px"    [icon]="'volume-off-outline'" pack="eva" status="primary"></nb-icon>
		</div>

			 
	</div>

</div>
